<template>
  <v-container fluid>
    <div class="d-flex align-center">
      <p
        class="pa-0 my-3 body-2 font-weight-bold blue-grey--text text--darken-3"
      >
        {{ title }}
      </p>
    </div>
    <div class="d-flex justify-space-between">
      <div style="width: 30%" class="d-flex flex-column">
        <StatementPrint
          data-testid="rootCausePage-paragraph-identifiedRoot"
          :paragraph="name"
          :title="$t('problem_solving.print.identified_root_cause_title')"
        />
        <StatementPrint
          data-testid="rootCausePage-paragraph-typeRoot"
          :paragraph="type"
          :title="$t('problem_solving.print.type_title')"
        />
        <StatementPrint
          data-testid="rootCausePage-paragraph-causeRoot"
          :paragraph="description"
          :title="$t('problem_solving.print.root_cause_analysis_title')"
        />
        <div class="mb-2">
          <span
            class="paragraph font-weight-bold blue-grey--text text--darken-3"
            >{{ $t('problem_solving.print.did_it_work') }}:</span
          >
          <div class="d-flex align-center">
            <v-icon class="blue-grey--text text--darken-3">
              {{ didItWorkedIcon }}
            </v-icon>
            <span
              class="paragraph font-weight-bold blue-grey--text text--darken-3 ml-2"
              >{{ didItWorkedText }}</span
            >
          </div>
        </div>
      </div>
      <div style="width:47%" class="d-flex flex-column">
        <StatementPrint
          data-testid="rootCausePage-paragraph-correctiveAction"
          :paragraph="correctiveAction"
          :title="$t('problem_solving.print.corrective_action_title')"
        />
        <StatementPrint
          data-testid="rootCausePage-paragraph-preventiveAction"
          :paragraph="actionDescription"
          :title="actionTitle"
        />
      </div>
      <div style="width: 20%" class="d-flex flex-column">
        <span
          class="paragraph font-weight-bold blue-grey--text text--darken-3 mb-2"
          >{{ $t('problem_solving.print.evidence_title') }}</span
        >
        <ImageMediaPrint :mediaObject="firstImage" />
        <div class="d-flex" style="flex-flow: wrap;">
          <div
            v-for="(image, index) in otherImages"
            class="mt-2"
            :key="index"
            style="min-width: 50%"
          >
            <ImageMediaPrint small :mediaObject="image" />
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import StatementPrint from './StatementPrint.vue'
import ImageMediaPrint from './ImageMediaPrint.vue'

export default {
  name: 'RootCausePrint',

  components: {
    StatementPrint,
    ImageMediaPrint,
  },

  props: {
    rootCause: {
      type: Object,
      required: true,
    },
  },

  computed: {
    title() {
      return this.$t('problem_solving.print.root_cause_title', {
        number: this.rootCause.position + 1,
      })
    },

    name() {
      return this.rootCause.name
    },

    description() {
      return this.rootCause.description
    },

    type() {
      return this.rootCause.type
    },

    correctiveAction() {
      return this.rootCause.correctiveAction
    },

    preventiveAction() {
      return this.rootCause.preventiveAction
    },

    correctiveLearning() {
      return this.rootCause?.correctiveLearning
    },

    didItWorked() {
      return this.rootCause?.correctiveActionWorked
    },

    didItWorkedText() {
      return this.didItWorked
        ? this.$t('problem_solving.print.yes_it_worked')
        : this.$t('problem_solving.print.no_it_didnt_work')
    },

    didItWorkedIcon() {
      return this.didItWorked
        ? 'mdi-check-circle-outline'
        : 'mdi-close-circle-outline'
    },

    actionTitle() {
      return this.didItWorked
        ? this.$t('problem_solving.print.preventive_action_title')
        : this.$t('problem_solving.print.corrective_learning_title')
    },

    actionDescription() {
      return this.didItWorked ? this.preventiveAction : this.correctiveLearning
    },

    firstImage() {
      return this.rootCause?.correctiveActionMedia?.[0] ?? {}
    },

    otherImages() {
      return this.rootCause?.correctiveActionMedia?.slice(1) ?? []
    },
  },
}
</script>
